import type { RootState } from '@generalTypes/rootStateTypes';
import { selectCurrentEditingNode } from '@store/selectors/asideSelectors';
import { get } from 'lodash';
import { useSelector } from 'react-redux';

export const useInitialValue = (property: string) => {
  return useSelector((state: RootState) => get(selectCurrentEditingNode(state), property));
};
